const styles = theme => ({
   root: {
     marginTop: 5,
     [theme.breakpoints.up('sm')]: {
       marginTop: 5,
     },
     [theme.breakpoints.up('md')]: {
       marginTop: 9,
     },
   },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/OARReport/components/CoreContent/components/Title/styles.js